import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular'
import { CommonModule } from '@angular/common';
import { AdmindecryptPageRoutingModule } from './decrypt-routing.module';
import { AdmindecryptPage } from './decrypt.page';
import { AdminService } from '../../../services/admin/admin.service';

import { NucamptopnavModule } from '../../../components/nucamptopnav/nucamptopnav.module';


import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [
    AdmindecryptPageRoutingModule,
    IonicModule,
    NucamptopnavModule,
    CommonModule,
    FormsModule,
    AdmindecryptPage
],
    providers: [
        AdminService,
    ]
})
export class AdmindecryptPageModule {}
